// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import mushodoPromise from '@webapp-next/lib/request/webapp/mushodo-promise';

export type CompanyStatEntry = {
  Company: Record<string, unknown> & { Id: string };
  Colleagues: number;
  Activated?: boolean;
};

/**
 * The target tenant's company-stat keyed by hostname — same shape as a single
 * entry of the GetAllMyCompanies response so it can be merged into the once
 * store identically.
 */
export type CompanyStatApiResponse = Record<string, CompanyStatEntry> & {
  error?: string;
};

/**
 * Fetches company-stat for a single tenant, off the all-tenants
 * GetAllMyCompanies stats fan-out. Used on the checkout critical path where
 * only the target tenant's data is needed.
 *
 * @param installId - The target tenant's install id
 */
export function loadCompanyStatForCheckout(
  installId: string
): Promise<CompanyStatApiResponse> {
  if (!installId) {
    throw new Error('installId is required to load company stat for checkout.');
  }

  return mushodoPromise<CompanyStatApiResponse>('GetCompanyStatForCheckout', {
    installId,
  });
}
